/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { FormBuilder } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckInViewProps } from './check-in-for-pickup';

/**
 * The check-in view for submitting check-in, capturing additional information, and showing check-in confirmation.
 * @param props - The check-in view properties.
 * @returns The check-in view as a react component.
 */
const CheckInViewComponent: React.FC<ICheckInViewProps> = (props: ICheckInViewProps) => {
    const {
        headerError,
        checkInForOrderPickup,
        confirmationComponent,
        viewState
    } = props;
    return (
        <>
            { viewState.isHeaderError && headerError }
            { !viewState.isHeaderError && ArrayExtensions.hasElements(props.config.additionalInformationKeys) &&
                <FormBuilder
                    heading={props.config.additionalInformationHeading ?? props.resources.additionalInformationDefaultHeading}
                    submitButtonText={props.resources.additionalInformationSubmitButtonText}
                    keys={props.config.additionalInformationKeys}
                    requiredValueMissingErrorMessage={props.resources.requiredValueMissingErrorMessage}
                    onSubmit={checkInForOrderPickup}
                    confirmationComponent={confirmationComponent}
                />}
            {
                !viewState.isHeaderError && !ArrayExtensions.hasElements(props.config.additionalInformationKeys) && viewState.isCheckedIn &&
                confirmationComponent
            }
        </>
    );
};

export default CheckInViewComponent;
